import { render } from "./LbrxRequestPopup.vue?vue&type=template&id=039e73c0&scoped=true"
import script from "./LbrxRequestPopup.vue?vue&type=script&lang=js"
export * from "./LbrxRequestPopup.vue?vue&type=script&lang=js"

import "./LbrxRequestPopup.vue?vue&type=style&index=0&id=039e73c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039e73c0"]])

export default __exports__